import React from "react";
import aboutImg from "../assets/astra_hack_logo.png"; // Using logo as fallback or keep existing if path is valid

const About = () => {
  return (
    <div id="about" className="relative py-20 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary rounded-2xl blur-2xl opacity-50 group-hover:opacity-75 transition-opacity" />
              <div className="glass-card p-4 rounded-2xl relative rotate-3 group-hover:rotate-0 transition-transform duration-500">
                <img
                  src="assets/images/resource/about.png"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = aboutImg;
                  }}
                  alt="About AstraHack"
                  className="rounded-xl w-full max-w-md h-auto object-cover"
                />
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="w-full md:w-1/2 space-y-6">
            <div className="space-y-2">
              <h4 className="text-primary font-bold tracking-wider uppercase">
                What is ASTRAHACK?
              </h4>
              <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
                Your path to learning <span className="gradient-text">Blockchain!</span>
              </h2>
              <h3 className="text-2xl font-semibold text-text-muted">Understand and Learn</h3>
            </div>

            <div className="space-y-4 text-text-muted text-lg leading-relaxed">
              <p>
                Welcome to ASTRAHACK! We're passionate about making blockchain technology
                understandable for everyone. Our platform offers a safe space for tutors and
                learners to explore how transactions happen in the digital world.
              </p>
              <p>
                Through interactive tools and guided practice, we break down complex concepts into
                simple steps. Whether you're curious about cryptocurrencies or interested in the
                potential of blockchain, we're here to guide you every step of the way. Join us on
                this journey of discovery and unlock the secrets of digital transactions!
              </p>
            </div>

            <div className="pt-4">
              <a href="#features" className="btn-primary">
                Start Learning
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
